<div class="modal-content" id="fisaSpatiuVerde">
   
    <div class="modal-body">
        <!-- Header -->
        <div *ngFor="let svRaport of svRaports" print-section [ngClass]="!$last ? 'pageBrakeAfter': ''">
            <div class="modal-header" style="text-align:center">
                <h5 class="modal-title">FISA ARBORELUI</h5>
            </div>
            <div print-section>
                <!--<h5>Anexa: Fisa spatiului verde</h5>-->
                <table id="tblHeaderInfo" width="100%" class="fa-table-style">
                    <col width="10%" />
                    <col width="22%" />
                    <col width="14%" />
                    <col width="18%" />
                    <col width="14%" />
                    <col width="18%" />
                    <tbody>
                        <tr>
                            <td>{{denumiriColoaneHeader.judetul}}:</td>
                            <td>{{svRaport.headInfo.judet}}</td>
                            <td>{{denumiriColoaneHeader.sectiunePlan}}:</td>
                            <td>{{svRaport.headInfo.sectiunePlan}}</td>
                            <td>{{denumiriColoaneHeader.codZonaValorica}}:</td>
                            <td>{{svRaport.headInfo.codZonaValorica}}</td>
                        </tr>
                        <tr>
                            <td>{{denumiriColoaneHeader.localitatea}}:</td>
                            <td>{{svRaport.headInfo.localitatea}}</td>
                            <td>{{denumiriColoaneHeader.nrCadastral}}:</td>
                            <td>{{svRaport.headInfo.nrCadastral}}</td>
                            <td>{{denumiriColoaneHeader.codZonaProtejata}}:</td>
                            <td>{{svRaport.headInfo.codZonaProtejata}}</td>
                        </tr>
                        <tr>
                            <td>{{denumiriColoaneHeader.codsiruta}}:</td>
                            <td>{{svRaport.headInfo.codSiruta}}</td>
                            <td>{{denumiriColoaneHeader.nrCarteFunciara}}:</td>
                            <td>{{svRaport.headInfo.nrCarteFunciara}}</td>
                            <td>{{denumiriColoaneHeader.codPostal}}:</td>
                            <td>{{svRaport.headInfo.codPostal}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <!-- Create map image-->
            <div print-section class="mapImageContainer">
                <h6>1. SCHITA AMPLASAMENTULUI TERENULUI SPATIU VERDE</h6>
                <img width="100%" id="mapImage" [src]="mapImgUrl" />
            </div>

            <!-- Adresa -->
            <div print-section>
                <h6>2. ADRESA:</h6>
                <p>{{svRaport.adresa}}</p>
                <h6>Localizare:</h6>
                <p>X: {{svRaport.long}}</p>
                <p>Y: {{svRaport.lat}}</p>
                <p>Z: {{svRaport.alt}}</p>
            </div>
           

            <!-- Date priviind vegetatia existenta in spatiul verde -->
            <div print-section>
                <h6>6. DATE PRIVIND VEGETATIA EXISTENTA PE TERENUL SPATIU VERDE:</h6>
                <div>
                    <table id="tblVegetatie" width="100%" class="table-bordered fa-table-style">
                        <col width="5%" />
                        <col width="5%" />
                        <col width="5%" />
                        <col width="5%" />
                        <col width="5%" />
                        <col width="5%" />
                        <col width="5%" />
                        <col width="5%" />
                        <col width="5%" />
                        <col width="5%" />
                        <col width="5%" />
                        <col width="5%" />
                        <col width="5%" />
                        <col width="5%" />
                        <thead>
                            <tr>
                                <th>{{denumireColoaneArbore.nr}}</th>
                                <th>{{denumireColoaneArbore.specia}}</th>
                                <th>{{denumireColoaneArbore.inaltimeArbore}}</th>
                                <th>{{denumireColoaneArbore.inaltimeTrunchi}}</th>
                                <th>{{denumireColoaneArbore.numarIdentificare}}</th>
                                <th>{{denumireColoaneArbore.ocrotit}}</th>
                                <th>{{denumireColoaneArbore.suport}}</th>
                                <th>{{denumireColoaneArbore.varsta}}</th>
                                <th>{{denumireColoaneArbore.sanatate}}</th>
                                <th>{{denumireColoaneArbore.intretinere}}</th>
                                <th>{{denumireColoaneArbore.diametru}}</th>
                                <th>{{denumireColoaneArbore.amplasare}}</th>
                                <th>{{denumireColoaneArbore.categorie}}</th>
                                <th>{{denumireColoaneArbore.lucrari}}</th>
                            </tr>
                            <tr>
                                <th>1</th>
                                <th>2</th>
                                <th>3</th>
                                <th>4</th>
                                <th>5</th>
                                <th>6</th>
                                <th>7</th>
                                <th>8</th>
                                <th>9</th>
                                <th>10</th>
                                <th>11</th>
                                <th>12</th>
                                <th>13</th>
                                <th>14</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let titem of svRaport.arbore">
                                <td>{{ titem.nr }}</td>
                                <td>{{ titem.specia }}</td>
                                <td>{{ titem.inaltimeArbore }}</td>
                                <td>{{ titem.inaltimeTrunchi }}</td>
                                <td>{{ titem.numarIdentificare }}</td>
                                <td>{{ titem.ocrotit }}</td>
                                <td>{{ titem.suport }}</td>
                                <td>{{ titem.varsta }}</td>
                                <td>{{ titem.sanatate }}</td>
                                <td>{{ titem.intretinere }}</td>
                                <td>{{ titem.diametru }}</td>
                                <td>{{ titem.amplasare }}</td>
                                <td>{{ titem.categorie }}</td>
                                <td>{{ titem.lucrari }}</td>
                            </tr>
                            
                        </tbody>
                        <tfoot>
                           
                        </tfoot>
                    </table>
                </div>
            </div>
          
            
            <!-- report footer-->
            <div print-section>
                <table id="tblReportFooter" width="100%">
                    <col width="60%" />
                    <col width="40%" />
                    <tr>
                        <td>Intocmit</td>
                        <td>Verificat si aprobat</td>
                    </tr>
                    <tr>
                        <td>extras din Registrul electronic al spatiilor verzi - {{svRaport.numeMunicipiu}}<br /> <a [href]="svRaport.numeSursaUrl">{{svRaport.numeSursaUrl}}</a></td>
                        <td>prin: {{svRaport.numeAprobat}}</td>
                    </tr>
                    <tr>
                        <td>Data: {{svRaport.printDate}}</td>
                        <td>Data: {{svRaport.dataAprobat}}</td>
                    </tr>
                </table>
            </div>
        </div>
    </div>
    <div class="modal-footer" print-remove>
        <button class="btn btn-primary" print-btn print-landscape><i class="fa fa-print"></i> Print</button>
        <button type="button" class="btn" (click)="cancel()">Inchide</button>
    </div>
</div>